import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, UpdateBeRankType } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateBeRankType } from '../businessEntityApi';

function* updateBeRankTypeSaga(action: UpdateBeRankType) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<{ businessEntityId: number; rankTypeId: number }> = yield call(
    updateBeRankType,
    action.payload
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(
      businessEntityActionCreators.setRankType({
        beId: response.value.businessEntityId,
        rankTypeId: response.value.rankTypeId
      })
    );
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBeRankType() {
  yield takeEvery(BusinessEntityActionKeys.UPDATE_BE_RANK_TYPE, updateBeRankTypeSaga);
}
